export const environment = {
    production: true,
    recaptcha: {
        siteKey: '6LcsHZ0jAAAAAFXjtTSWFFzOKMIHiM2YJqIt7otq',
    },
    appInsightsInstrumentationKey: '0f744880-ee18-4cc9-8dba-20196dc489fe',
    baseUrl: "https://webapi-ir-contest-prod-cus-01.azurewebsites.net",
    googleMapApiKey: "AIzaSyAiMGzXgD4l9LyL4Ay-mOdA_ZGoWYWIvAs",
};
